import React, { useEffect, useState } from 'react';

// Component to render each event
const Event = ({ title, datetime, venue, offers, url }) => {
    const eventDate = new Date(datetime)
    return (
        <div className="event">
            <div className="event-info">
                <div className="date">
                    <span className="day">{eventDate.getDate()}</span>
                    <span className="month">{eventDate.toLocaleDateString('default', { month: 'short' })}</span>
                    <span className="year">{eventDate.getFullYear()}</span>
                </div>
                <div className="details">
                    <h3 className="title">{title}</h3>
                    <span className="location">{venue.name} - {venue.location}</span>
                </div>
                {
                    offers && offers[0] && offers[0].url ? <div className="link"><a href={offers[0].url}>Get Tickets</a></div>
                        : url && <div className="link"><a href={url}>Link</a></div>
                }
            </div>
        </div>
    )
};

function Events() {
    const [eventsData, setEventsData] = useState(null);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                console.log("Fetching")
                const response = await fetch('https://rest.bandsintown.com/artists/id_15590656/events?app_id=28a79f4ef84696d97667ea3371cfefe5');
                if (!response.ok) {
                    throw new Error('Failed to fetch events data');
                }
                const eventData = await response.json();
                console.log(eventData)
                setEventsData(eventData);
            } catch (error) {
                console.error('Error fetching events data:', error);
            }
        };

        fetchEvents();
    }, []); // Empty dependency array to run the effect only once

    // Check if eventsData is null or not
    if (eventsData === null) {
        return <div>Loading...</div>;
    }

    // Filter out events with past dates
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component
    const upcomingEvents = eventsData.filter(event => new Date(event.datetime) >= today);

    return (
        <section id="events">
            <h2>Events</h2>
            <div className="events">
                {upcomingEvents.length === 0 ? (
                    <p>No upcoming events</p>
                ) : (
                    upcomingEvents.map((event, index) => {
                        console.log(event)
                        return (
                            <Event key={index} {...event} />
                        )
                    })
                )}
            </div>
            <small>Bookings: <i><a href="mailto:bookings@timewaster.nl">bookings@timewaster.nl</a></i></small>
        </section>
    );
}

export default Events;
